/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.passes.create.series.controllers', [
  'ui.bootstrap',
  'acme.common.service.helpers',
  'acme.common.service.passes',
  'acme.view.application.passes.create.series.modals.remove.controllers'
])

.controller('PassesCreateSeriesController', ['$scope', '$uibModal', 'HelpersService', 'PassesService', function($scope, $uibModal, HelpersService, PassesService) {

    $scope.passesCreateSeries = {

      model: [],
      segmentTypes: PassesService.series.getSegmentTypes(),

      init: function() {
        this.model = PassesService.series.getModel();
        $scope.$on('PassesCreateController::UpdateModel', this.onPassesCreateControllerUpdateModel);
        $scope.$on('PassesCreateController::Save', this.onPassesCreateControllerSave);
        $scope.$on('PassesCreateController::CharactersUpdate', this.onPassesCreateControllerCharactersUpdate);
        $scope.$on('$destroy', this.onDestroy);
      },

      updateRangeDisplayTitle: function(series) {
        var i, ii,
            endRange = '',
            startRange = '';

        for (i = 0, ii = series.segments.length; i < ii; i++) {
          if (this.isValueSegmentType(series.segments[i].type)) {
            startRange += series.segments[i].value;
            endRange += series.segments[i].value;
          }else if (this.isRangeSegmentType(series.segments[i].type)) {
            startRange += series.segments[i].startSequence;
            endRange += series.segments[i].endSequence;
          }
        }

        series.valid = true;

        if ((startRange + "").length < PassesService.getModel().characters) {
          startRange += '...';
          series.valid = false;
        }else if ((startRange + "").length > PassesService.getModel().characters) {
          series.valid = false;
        }

        if ((endRange + "").length < PassesService.getModel().characters) {
          endRange += '...';
        }

        series.rangeDisplayTitleStart = startRange;
        series.rangeDisplayTitleEnd = endRange;
        series.rangeDisplayTitle = series.rangeDisplayTitleStart + ' to ' + series.rangeDisplayTitleEnd;

      },

      checkValid: function() {

        var i, ii,
            j, jj,
            r = true;

        if (this.model instanceof Array) {
          if (this.model.length) {
            outer: for (i = 0, ii = this.model.length; i < ii; i++) {
              if (this.model[i].segments instanceof Array) {
                for (j=0,jj=this.model[i].segments.length;j<jj;j++) {
                  if (!this.model[i].segments[j].valid) {
                    r = false;
                    break outer;
                  }
                }
              }
              if (!this.model[i].valid) {
                r = false;
                break;
              }
            }
          }else{
            r = false;
          }
        }else{
          r = false;
        }

        return r;

      },

      findSegmentType: function(type) {
        return PassesService.series.findSegmentType(type);
      },

      getSegmentType: function(type) {
        var found = PassesService.series.findSegmentType(type);

        if (found) {
          return found.segmentType;
        }else{
          return {
            type: '',
            label: '',
            shortLabel: ''
          };
        }
      },

      showRemoveNotification: function (segments, index, type, name) {
        var self = $scope.passesCreateSeries,
            _type = HelpersService.cap(type);

        self.modalDialog = $uibModal.open( {
          templateUrl: 'views/application/views/passes/create/series/modals/remove/remove.tpl.html',
          size: 'md',
          controller: 'PassesCreateSeriesModalsRemoveController',
          resolve: {
            type: function() {
              return _type;
            },
            name: function() {
              return name;
            }
          }
        });

        self.modalDialog.result.then( function() {
          if (type === 'series') {
            self.removeSeries(index);
          }else if (type === 'segment') {
            self.removeSegment(segments, index);
          }
        }, function() {
          // do nothing
        });
      },

      removeSeries: function(index) {
        this.model.splice(index, 1);
        PassesService.series.setModel(this.model);
        this.updateSeries();
      },

      removeSegment: function(segments, index) {
        segments.splice(index, 1);
        PassesService.series.setModel(this.model);
        this.updateSeries();
      },

      addSeries: function() {
        PassesService.series.setModel(this.model);
        PassesService.series.addSeries();
        this.model = PassesService.series.getModel();
      },

      addSegment: function(series) {
        PassesService.series.addSegment(series);
        this.checkSequence(series, series.segments[series.segments.length - 1]);
      },

      isValueSegmentType: function(type) {
        return PassesService.series.isValueSegmentType(type);
      },

      isRangeSegmentType: function(type) {
        return PassesService.series.isRangeSegmentType(type);
      },

      checkSeries: function(series) {

        var i, ii,
            characters = 0;

        for (i = 0, ii = series.segments.length; i < ii; i++) {
          characters += series.segments[i].characters;
        }

        series.characters = characters;

        this.updateRangeDisplayTitle(series);

      },

      checkValue: function(series, segment) {
        segment.value += "";
        segment.valid = (segment.value && segment.value.length) ? true : false;
        segment.characters = segment.value.length || 0;
        this.checkSeries(series);
      },

      checkSequence: function(series, segment) {
        var startNumber = parseInt(segment.startSequence, 10),
            endNumber = parseInt(segment.endSequence, 10);

        segment.startSequence += "";
        segment.endSequence += "";

        if (!isNaN(startNumber) && !isNaN(endNumber)) {
          if (segment.type === 'ascendingRange') {
            segment.valid = (endNumber > startNumber);
          }else if (segment.type === 'descendingRange') {
            segment.valid = (endNumber < startNumber);
          }else{
            segment.valid = false;
          }
        }

        segment.characters = Math.max(segment.startSequence.length, segment.endSequence.length) || 0;
        this.checkSeries(series);
      },

      updateSeries: function() {

        var i, ii,
            j, jj;

        if (this.model instanceof Array) {
          for (i = 0, ii = this.model.length; i < ii; i++) {
            for (j = 0, jj = this.model[i].segments.length; j < jj; j++) {
              if (this.isValueSegmentType(this.model[i].segments[j].type)) {
                this.checkValue(this.model[i], this.model[i].segments[j]);
              } else if (this.isRangeSegmentType(this.model[i].segments[j].type)) {
                this.checkSequence(this.model[i], this.model[i].segments[j]);
                this.model[i].segments[j].startSequence = PassesService.series.addLeadingZeros(this.model[i].segments[j].startSequence, this.model[i].segments[j].characters);
              }
            }
            this.updateRangeDisplayTitle(this.model[i]);
          }
        }

      },

      format: function(segment, sequence) {
        if (sequence === 'start') {
          segment.endSequence = PassesService.series.addLeadingZeros(segment.endSequence, segment.characters);
        }
        if (sequence === 'end') {
          segment.startSequence = PassesService.series.addLeadingZeros(segment.startSequence, segment.characters);
        }
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      },

      onPassesCreateControllerUpdateModel: function(e, data) {
        var self = $scope.passesCreateSeries;

        self.model = PassesService.series.getModel();
        self.updateSeries();
        PassesService.series.setModel(self.model);
      },

      onPassesCreateControllerSave: function(e, data) {
        var self = $scope.passesCreateSeries;

        if (self.checkValid()) {
          PassesService.series.setModel(self.model);
          $scope.$emit('PassesCreateController::TabCheck', {
            tab: 'series',
            invalid: false
          });
        }else{
          $scope.$emit('PassesCreateController::TabCheck', {
            tab: 'series',
            invalid: true,
            message: 'Missing or invalid series'
          });
        }

      },

      onPassesCreateControllerCharactersUpdate: function(e, data) {
        $scope.passesCreateSeries.updateSeries();
      },

      onDestroy: function(e, data) {
        var self = $scope.passesCreateSeries;

        PassesService.series.setModel(self.model);
      }

    };

    $scope.passesCreateSeries.init();

}]);